import { FC } from "react";
import { useBranding } from "../context/BrandingContext";

/**
 * Header component with dynamic branding
 */
const Header: FC = () => {
  const brand = useBranding();

  return (
    <header className="bg-white shadow-sm border-b border-neutral-200">
      <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo and Name */}
          <div className="flex items-center gap-4">
            <img
              src={brand.logo.title}
              alt={brand.organizationName}
              className="h-12 w-auto object-contain"
            />
          </div>

          {/* Contact Info */}
          <div className="hidden sm:flex items-center gap-4 text-sm">
            <a
              href={`tel:${brand.mobile.replace(/\s/g, "")}`}
              className="flex items-center gap-1 text-neutral-600 hover:text-brand-primary transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              {brand.mobile}
            </a>
            <span className="inline-flex items-center rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              🔒 Secure UPI Payment
            </span>
          </div>
        </div>

        {/* Slogan */}
        <p className="mt-1 text-sm text-neutral-500 italic">{brand.slogan}</p>
      </div>
    </header>
  );
};

export default Header;
